import React, { Component } from "react";

import Login from "./components/Login";
import Master from "./components/Master";
import './App.css';

class App extends Component {

	constructor() {
		super();

		this.state = {
			logged: false
		};
	}

	diaplyView = () => {

		if (!this.state.logged) {
			return <Login loginHanlder={this.onLoginHandler}/>
		}

		return <Master />;
	}

	onLoginHandler = (success) => {
		this.setState({ logged: success});
	}

	render() {
		return (
			<div className="App">
				{ this.diaplyView() }
			</div>
		);
	}
  
}

export default App;
